// // /**
// //  * React Query Client Configuration
// //  *
// //  * Why: Configure global React Query Settings
// //  * What: Sets default options for queries and mutations
// //  * Benefit: Consistent behaviour across all queries
// //  */

// // import { QueryClient } from "@tanstack/react-query";
// // import { logger } from "../utils";

// // /**
// //  * Create and configure React Query Client
// //  */

// // export const createQueryClient = (): QueryClient => {
// //   return new QueryClient({
// //     defaultOptions: {
// //       // Query defaults
// //       queries: {
// //         // Retry failed requests 2 times
// //         retry: 3,

// //         // Retry with exponential backoff
// //         retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),

// //         // Refetch on window focus in production
// //         refetchOnWindowFocus: import.meta.env.PROD,

// //         // Refetch on reconnect
// //         refetchOnReconnect: true,

// //         // Consider data stale after 5 minutes
// //         staleTime: 5 * 60 * 1000,

// //         // Keep unused data in cache for 10 minutes
// //         gcTime: 10 * 60 * 1000,

// //         // Throw errors to error boundries
// //         throwOnError: false,
// //       },

// //       // Mutation defaults
// //       mutations: {
// //         // Don't retry mutations by defaults
// //         retry: 0,

// //         // Error handling
// //         onError: (error) => {
// //           logger.error("Mutation error", error);
// //         },
// //       },
// //     },
// //   });
// // };

// // // Export singleton instance
// // export const queryClient = createQueryClient();

// /**
//  * React Query Client Configuration
//  *
//  * Why: Configure global React Query settings
//  * What: Sets default options for queries and mutations, plus a focus manager
//  *       tuned for Stripe Elements iframes and a retry policy that treats auth
//  *       failures as verdicts rather than transient errors.
//  * Benefit: Consistent behaviour across all queries; the 15s session poll behaves.
//  */

// import { QueryClient, focusManager } from "@tanstack/react-query";
// import { logger } from "../utils";

// /**
//  * Create and configure React Query Client
//  */
// export const createQueryClient = (): QueryClient => {
//   return new QueryClient({
//     defaultOptions: {
//       // Query defaults
//       queries: {
//         /**
//          * ============================================================================
//          * DO NOT RETRY A 401. IT IS AN ANSWER, NOT A FAILURE.
//          * ============================================================================
//          * Plain `retry: 3` retries EVERYTHING three times, including a 401. But a 401
//          * from the session poll is not a transient error — it is the server saying
//          * "this session is dead". Retrying it means: the user was logged out
//          * elsewhere, the poll gets 401, and instead of reacting your app asks three
//          * more times, with exponential backoff, over the next several seconds, before
//          * the interceptor finally fires the logout.
//          *
//          * During those seconds the UI still looks logged in on a session the server
//          * has already killed. On a revoked session that is a real hole — a promo tab
//          * re-mint or an admin force-logout should take effect NOW.
//          *
//          * A 401/403 is a verdict; accept it immediately. A 4xx is a client mistake
//          * that will not fix itself on retry. Only the 5xx/timeout family is worth the
//          * original three attempts.
//          */
//         retry: (failureCount, error) => {
//           const status = (error as { response?: { status?: number } })?.response
//             ?.status;

//           // Auth verdicts — never retry. Let the interceptor log them out at once.
//           if (status === 401 || status === 403) return false;

//           // Client mistakes (bad request, not found, conflict) — pointless to retry.
//           if (status && status >= 400 && status < 500) return false;

//           // 5xx, network, timeout — the original behaviour.
//           return failureCount < 3;
//         },

//         // Retry with exponential backoff
//         retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),

//         // Refetch on window focus in production
//         refetchOnWindowFocus: import.meta.env.PROD,

//         // Refetch on reconnect
//         refetchOnReconnect: true,

//         // Consider data stale after 5 minutes
//         staleTime: 5 * 60 * 1000,

//         // Keep unused data in cache for 10 minutes
//         gcTime: 10 * 60 * 1000,

//         // Throw errors to error boundaries
//         throwOnError: false,
//       },

//       // Mutation defaults
//       mutations: {
//         // Don't retry mutations by default. A double-submitted payment is worse
//         // than a failed one, so mutations must never auto-retry.
//         retry: 0,

//         // Error handling
//         onError: (error) => {
//           logger.error("Mutation error", error);
//         },
//       },
//     },
//   });
// };

// /**
//  * ============================================================================
//  * installFocusManager — CALL ONCE from main.tsx, above createRoot.
//  * ============================================================================
//  * WHY THE DEFAULT focus BEHAVIOUR BREAKS THE PAYMENT PAGE
//  *
//  * `refetchOnWindowFocus: PROD` is a good default, but React Query's idea of
//  * "focus" is broader than the window: by default ANY focus event triggers a
//  * refetch, and a Stripe Elements card input is an IFRAME.
//  *
//  * So on /payment/methods/credit-card, every click from the card number into the
//  * expiry field fires a focus event, React Query thinks the app regained focus,
//  * and the 15-second session poll refetches. Card / expiry / CVC / ZIP is four
//  * session-status calls while the user is typing their card.
//  *
//  * Keying "focused" off document.hasFocus() — which is FALSE when focus is inside
//  * a cross-origin iframe — makes the Stripe clicks stop counting. A real tab
//  * switch still counts.
//  *
//  * WHY A FUNCTION, NOT INLINE: focusManager is a module-level singleton, set
//  * imperatively once at boot. In a component useEffect it would install AFTER the
//  * first render, and the first focus event of the session is exactly the one you
//  * want governed.
//  */
// export const installFocusManager = (): void => {
//   focusManager.setEventListener((handleFocus) => {
//     const onFocus = () => {
//       // false when focus is inside a cross-origin iframe (Stripe Elements)
//       handleFocus(document.hasFocus());
//     };

//     if (typeof window !== "undefined" && window.addEventListener) {
//       window.addEventListener("visibilitychange", onFocus, false);
//       window.addEventListener("focus", onFocus, false);
//     }

//     return () => {
//       window.removeEventListener("visibilitychange", onFocus);
//       window.removeEventListener("focus", onFocus);
//     };
//   });
// };

// // Export singleton instance
// export const queryClient = createQueryClient();

// ============================================================================
// DESTINATION:  src/core/query/queryClient.ts
// ACTION:       REPLACE your existing file
// ============================================================================

/**
 * React Query Client Configuration
 *
 * Why: Configure global React Query settings
 * What: Sets default options for queries and mutations, plus a focus manager
 *       tuned for Stripe Elements iframes and a retry policy that treats auth
 *       failures as verdicts rather than transient errors.
 * Benefit: Consistent behaviour across all queries; the 15s session poll behaves.
 */

import { QueryClient, focusManager } from "@tanstack/react-query";
import { logger } from "../utils";

/**
 * Create and configure React Query Client
 */
export const createQueryClient = (): QueryClient => {
  return new QueryClient({
    defaultOptions: {
      // Query defaults
      queries: {
        /**
         * ============================================================================
         * DO NOT RETRY A 401. IT IS AN ANSWER, NOT A FAILURE.
         * ============================================================================
         * Plain `retry: 3` retries EVERYTHING three times, including a 401. But a 401
         * from the session poll is not a transient error — it is the server saying
         * "this session is dead". Retrying it means: the user was logged out
         * elsewhere, the poll gets 401, and instead of reacting your app asks three
         * more times, with exponential backoff, over the next several seconds, before
         * the interceptor finally fires the logout.
         *
         * During those seconds the UI still looks logged in on a session the server
         * has already killed. On a revoked session that is a real hole — a promo tab
         * re-mint or an admin force-logout should take effect NOW.
         *
         * A 401/403 is a verdict; accept it immediately. A 4xx is a client mistake
         * that will not fix itself on retry. Only the 5xx/timeout family is worth the
         * original three attempts.
         */
        retry: (failureCount, error) => {
          const status = (error as { response?: { status?: number } })?.response
            ?.status;

          // Auth verdicts — never retry. Let the interceptor log them out at once.
          if (status === 401 || status === 403) return false;

          // Client mistakes (bad request, not found, conflict) — pointless to retry.
          if (status && status >= 400 && status < 500) return false;

          // 5xx, network, timeout — the original behaviour.
          return failureCount < 3;
        },

        // Retry with exponential backoff
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),

        // Refetch on window focus in production
        refetchOnWindowFocus: import.meta.env.PROD,

        // Refetch on reconnect
        refetchOnReconnect: true,

        // Consider data stale after 5 minutes
        staleTime: 5 * 60 * 1000,

        // Keep unused data in cache for 10 minutes
        gcTime: 10 * 60 * 1000,

        // Throw errors to error boundaries
        throwOnError: false,
      },

      // Mutation defaults
      mutations: {
        // Don't retry mutations by default. A double-submitted payment is worse
        // than a failed one, so mutations must never auto-retry.
        retry: 0,

        // Error handling
        onError: (error) => {
          logger.error("Mutation error", error);
        },
      },
    },
  });
};

/**
 * ============================================================================
 * installFocusManager — CALL ONCE from main.tsx, above createRoot.
 * ============================================================================
 * WHY THE DEFAULT focus BEHAVIOUR BREAKS THE PAYMENT PAGE
 *
 * `refetchOnWindowFocus: PROD` is a good default, but React Query's idea of
 * "focus" is broader than the window: by default ANY focus event triggers a
 * refetch, and a Stripe Elements card input is an IFRAME.
 *
 * So on /payment/methods/credit-card, every click from the card number into the
 * expiry field fires a focus event, React Query thinks the app regained focus,
 * and the 15-second session poll refetches. Card / expiry / CVC / ZIP is four
 * session-status calls while the user is typing their card.
 *
 * Keying "focused" off document.hasFocus() — which is FALSE when focus is inside
 * a cross-origin iframe — makes the Stripe clicks stop counting. A real tab
 * switch still counts.
 *
 * WHY A FUNCTION, NOT INLINE: focusManager is a module-level singleton, set
 * imperatively once at boot. In a component useEffect it would install AFTER the
 * first render, and the first focus event of the session is exactly the one you
 * want governed.
 */
export const installFocusManager = (): void => {
  focusManager.setEventListener((handleFocus) => {
    const onFocus = () => {
      // false when focus is inside a cross-origin iframe (Stripe Elements)
      handleFocus(document.hasFocus());
    };

    if (typeof window !== "undefined" && window.addEventListener) {
      window.addEventListener("visibilitychange", onFocus, false);
      window.addEventListener("focus", onFocus, false);
    }

    return () => {
      window.removeEventListener("visibilitychange", onFocus);
      window.removeEventListener("focus", onFocus);
    };
  });
};

// Export singleton instance
export const queryClient = createQueryClient();
